export var CollectionEnum;
(function (CollectionEnum) {
    CollectionEnum["CollectionId"] = "collection_id";
    CollectionEnum["Name"] = "name";
    CollectionEnum["Owner"] = "owner";
    CollectionEnum["OwnerNormalized"] = "owner_normalized";
    CollectionEnum["TokenPrefix"] = "token_prefix";
})(CollectionEnum || (CollectionEnum = {}));
export var ExtrinsicsStatsTypeEnum;
(function (ExtrinsicsStatsTypeEnum) {
    ExtrinsicsStatsTypeEnum["Coins"] = "COINS";
    ExtrinsicsStatsTypeEnum["Tokens"] = "TOKENS";
})(ExtrinsicsStatsTypeEnum || (ExtrinsicsStatsTypeEnum = {}));
export var GqlOrderByParamsArgs;
(function (GqlOrderByParamsArgs) {
    GqlOrderByParamsArgs["Asc"] = "asc";
    GqlOrderByParamsArgs["AscNullsFirst"] = "asc_nulls_first";
    GqlOrderByParamsArgs["AscNullsLast"] = "asc_nulls_last";
    GqlOrderByParamsArgs["Desc"] = "desc";
    GqlOrderByParamsArgs["DescNullsFirst"] = "desc_nulls_first";
    GqlOrderByParamsArgs["DescNullsLast"] = "desc_nulls_last";
})(GqlOrderByParamsArgs || (GqlOrderByParamsArgs = {}));
export var GroupByIntervalEnum;
(function (GroupByIntervalEnum) {
    GroupByIntervalEnum["Day"] = "day";
    GroupByIntervalEnum["Hour"] = "hour";
    GroupByIntervalEnum["Month"] = "month";
    GroupByIntervalEnum["Week"] = "week";
    GroupByIntervalEnum["Year"] = "year";
})(GroupByIntervalEnum || (GroupByIntervalEnum = {}));
export var TimestampTypeEnum;
(function (TimestampTypeEnum) {
    TimestampTypeEnum["Milliseconds"] = "MILLISECONDS";
    TimestampTypeEnum["Unix"] = "UNIX";
})(TimestampTypeEnum || (TimestampTypeEnum = {}));
export var TokenEnum;
(function (TokenEnum) {
    TokenEnum["CollectionId"] = "collection_id";
    TokenEnum["CollectionName"] = "collection_name";
    TokenEnum["Owner"] = "owner";
    TokenEnum["OwnerNormalized"] = "owner_normalized";
    TokenEnum["TokenId"] = "token_id";
    TokenEnum["TokenName"] = "token_name";
    TokenEnum["TokenPrefix"] = "token_prefix";
    TokenEnum["TokensOwner"] = "tokens_owner";
})(TokenEnum || (TokenEnum = {}));
export var TokenOwnersEnum;
(function (TokenOwnersEnum) {
    TokenOwnersEnum["Amount"] = "amount";
    TokenOwnersEnum["CollectionId"] = "collection_id";
    TokenOwnersEnum["DateCreated"] = "date_created";
    TokenOwnersEnum["Owner"] = "owner";
    TokenOwnersEnum["OwnerNormalized"] = "owner_normalized";
    TokenOwnersEnum["TokenId"] = "token_id";
})(TokenOwnersEnum || (TokenOwnersEnum = {}));
export var TokenTypeEnum;
(function (TokenTypeEnum) {
    TokenTypeEnum["Fractional"] = "FRACTIONAL";
    TokenTypeEnum["Nft"] = "NFT";
    TokenTypeEnum["Rft"] = "RFT";
})(TokenTypeEnum || (TokenTypeEnum = {}));
export const NftsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'nfts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tokens' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'offset' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'where' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: '_or' },
                                            value: {
                                                kind: 'ListValue',
                                                values: [
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'owner' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        kind: 'ObjectValue',
                                                        fields: [
                                                            {
                                                                kind: 'ObjectField',
                                                                name: { kind: 'Name', value: 'owner_normalized' },
                                                                value: {
                                                                    kind: 'ObjectValue',
                                                                    fields: [
                                                                        {
                                                                            kind: 'ObjectField',
                                                                            name: { kind: 'Name', value: '_eq' },
                                                                            value: { kind: 'Variable', name: { kind: 'Name', value: 'address' } },
                                                                        },
                                                                    ],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'token_id' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'token_name' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'image' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'collection_id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'collection' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=graphql.js.map